var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"control-label",domProps:{"innerHTML":_vm._s(_vm.$t(_vm.label))}}),_c('p',{staticClass:"form-control-static"},[_vm._v(_vm._s(_vm.displayValue))])])
}
var staticRenderFns = []

export { render, staticRenderFns }